import { ChildModel, ModelBase } from 'store/model-base';
import { OrderStatus, TransactionType } from 'my-account/constants';
import { OrderItem } from 'store/order/models';

export class OrderTransaction extends ModelBase {
    public static storeName: string = 'orderTransaction';

    public id: Id;
    public status: OrderStatus;
    public submittedDate: string;
    public amount: number;
    public isLegacy: boolean;
    public shipments: Shipment[];
    public orderItems: OrderItem[];

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'orderItems',
            model: OrderItem
        }];
    }

    public get title(): string {
        // exchange needs to come first before return
        // as exchange will have both orderitems exchange and return type
        switch (true) {
            case this.hasExchange:
                return `Order #${this.id.value} (Exchange)`;
            case this.hasBackOrder:
                return `Order #${this.id.value} (Backorder)`;
            case this.hasUpgrade:
                return `Order #${this.id.value} (Upgrade)`;
            case this.hasPreOrder:
                return `Order #${this.id.value} (Pre-order)`;
            case this.hasReturn:
                return `Order #${this.id.value} (Return)`;
            default:
                return `Order #${this.id.value}`;
        }
    }

    public get hasPreOrder(): boolean {
        return this.orderItems.some((item: OrderItem) => item.isPreOrderItem);
    }

    public get hasBackOrder(): boolean {
        return this.orderItems.some((item: OrderItem) => item.isBackOrderItem);
    }

    public get returnItem(): OrderItem {
        return this.orderItems.find((item: OrderItem) => item.isReturnItem);
    }

    public get hasReturn(): boolean {
        return Boolean(this.returnItem);
    }

    public get hasExchange(): boolean {
        return this.orderItems.some((item: OrderItem) => item.isExchangeItem || item.isWarrantyExchangeItem);
    }

    public get hasUpgrade(): boolean {
        return this.orderItems.some((item: OrderItem) => item.isUpgradeItem);
    }

    public get hasRefundedOrChargedReturn(): boolean {
        // this method is only for return and exchange order
        return this.returnItem && (this.returnItem.isRefundItem || this.returnItem.isChargedItem);
    }

    public get orderType(): string {
        switch (true) {
            case this.hasExchange:
                return TransactionType.EXCHANGE_ORDER;
            case this.hasReturn:
                return TransactionType.RETURN_ORDER;
            case this.hasUpgrade:
                return TransactionType.UPGRADE_ORDER;
            default:
                return TransactionType.ORDER;
        }
    }
}
